import React from "react"
import '../App.css'
import { Link, useLocation } from "react-router-dom"

export default function Header() {
  const location = useLocation()
  
  return (
    <header>
      <div className="container">
        <div className="inner-content">
          <div className="brand">
            <Link to="/"><img className="logo" src={'logo-snippet.png'} alt={`company logo`}/></Link>
          </div>
          <ul className="nav-links">
            {
              location.pathname === '/'
              ?
              <li>
              <Link className="nav" to="/portfolio">My Portfolio</Link>
            </li>
            : 
            <li>
              <Link className="nav" to="/">Home</Link>
            </li>
            }
            {/* <li>
              <Link className="nav" to="/trending">Trending</Link>
            </li> */}
          </ul>
        </div>
      </div>
    </header>
  );
};